

























import { DateType, DateFormat, currentLocale } from 'expangine-runtime';
import { friendlyList } from '../../../common';
import TypeEditorBase from '../TypeEditorBase';


export default TypeEditorBase<DateType, any>().extend({
  name: 'DateEditor',
  computed: {
    description(): string {
      const { validateMin, validateMax, forceMin, forceMax, forceStartOf, 
        forceEndOf, parseAsUTC, withTime } = this.type.options;
      const things: string[] = [];

      const format = withTime ? 'lll' : 'll';

      if (withTime) {
        things.push('with time');
      }
      if (parseAsUTC) {
        things.push('parse as UTC');
      }
      if (validateMin) {
        things.push('must be on or after ' + DateFormat.format(format, [validateMin, currentLocale]));
      }
      if (validateMax) {
        things.push('must be before ' + DateFormat.format(format, [validateMax, currentLocale]));
      }
      if (forceMin) {
        things.push('forced to be on or after ' + DateFormat.format(format, [forceMin, currentLocale]));
      }
      if (forceMax) {
        things.push('forced to be before ' + DateFormat.format(format, [forceMax, currentLocale]));
      }
      if (forceStartOf) {
        things.push('force to start of ' + forceStartOf);
      }
      if (forceEndOf) {
        things.push('force to end of ' + forceEndOf);
      }

      return friendlyList(things);
    },
  },
});
